import Persona from './persona';
import { connect } from 'react-redux';
import { RootDispatch } from '../../store';

export const mapDispatch = (dispatch: RootDispatch) => ({
  onSignOut: dispatch.auth.signOutRequest,
});

export default connect(() => ({}), mapDispatch)(Persona);
